import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-find-information',
  templateUrl: './find-information.component.html',
  styleUrls: ['./find-information.component.css'],
})
export class FindInformationComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
